module.exports = __webpack_public_path__ + "static/media/Cream.2d6965ad.svg";